import { render, staticRenderFns } from "./YoutubeView.vue?vue&type=template&id=59fe7531&"
import script from "./YoutubeView.vue?vue&type=script&lang=js&"
export * from "./YoutubeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports